import Isotope from './Isotope';
new Isotope;
